import React, { FC } from 'react';

export const FacebookIcon: FC<{ className?: string; href?: string }> = (props) => {
  return (
    <a className={props.className} href={props.href}>
      <svg width="8" height="18" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M5.714 3.6H8V0H5.369c-3.727 0-3.64 3.154-3.64 3.625V6H0v3.6h1.73V18h3.413V9.6h2.286L8 6H5.143V4.2c0-.394.214-.6.571-.6"
          fill="#BEBEBE"
          fillRule="evenodd"
        ></path>
      </svg>
    </a>
  );
};
